import { cn } from "@/lib/utils";
import * as settingsStyles from "../../pages/SettingsPage.styles";

const buttonGroup = "flex gap-3";

const timePicker = "inline-flex items-center gap-2";

const timeSeparator = "text-muted-foreground text-lg select-none leading-none pb-0.5";

const errorText = "text-sm text-destructive mt-1";

const scheduleStatus = "inline-flex items-center gap-1.5 ml-3 px-2 py-0.5 text-xs font-medium rounded-full bg-success/10 text-success";

const scheduleStatusDot = "w-1.5 h-1.5 rounded-full bg-success inline-block";

const container = "mt-4 space-y-5";

const formLabel = "text-sm font-medium text-foreground";

const timePickerIcon = "h-4 w-4 text-muted-foreground shrink-0";

const timeSelect = cn(settingsStyles.select, "w-24");

const amountInput = cn(settingsStyles.select, "w-40 mt-2");

export {
  buttonGroup,
  timePicker,
  timeSeparator,
  errorText,
  scheduleStatus,
  scheduleStatusDot,
  container,
  formLabel,
  timePickerIcon,
  timeSelect,
  amountInput,
};
